export const apiCallParameters = {
    STAFFS_RATING_PROCESSOR_API_NAME: "StaffsRatingProcessor",
    STAFFS_RATING_PROCESSOR_LAMBDA: "StaffsRatingProcessorLambda",
    UPLOAD_STAFFS_RATING_FILE: "uploadStaffsRatingFile"
}
export const STAFFS_RATING_PROCESSOR_TOOL = "VASStaffsRatingProcessorAuthZ"
export const ENABLED_REALM_LIST = ["EUAmazon"]
export const SUCCESS = "SUCCESS"
export const FAILURE = "FAILURE"